import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import usePreviewNotice from "features/owner/hooks/usePreviewNotice";
import { hw } from "features/homework/homeworkUi";

interface PreviewNoticeProps{
    teacher:boolean
}

const PreviewNotice = ({teacher}:PreviewNoticeProps) => {
    const {notices} = usePreviewNotice(teacher);
    const navigate = useNavigate();

    const formatDate = (value: Date) => {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, "0");
        const day = String(value.getDate()).padStart(2, "0");
        return `${year}.${month}.${day}`;
    };

    if (!notices.length) {
        return (
            <Empty>
                등록된 공지가 없습니다.
            </Empty>
        );
    }

    return(
        <Container>
            {notices.map((item, index) => {
                const date = item.register_date.toDate();
                return (
                    <Item key={index + 1} type="button" onClick={() => navigate(teacher ? "/teacher/notice" : "/owner/notice")}>
                        <DateText>{formatDate(date)}</DateText>
                        <TitleText>{item.title}</TitleText>
                    </Item>
                )
            })}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
`

const Empty = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 8px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`

const Item = styled.button`
    appearance: none;
    border: none;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 14px;
    border-radius: 10px;
    background: ${hw.bg};
    cursor: pointer;
    text-align: left;
    transition: background 0.15s ease;

    &:hover {
        background: ${hw.brandSoft};
    }
`

const DateText = styled.span`
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
`

const TitleText = styled.span`
    color: ${hw.text};
    font-size: 14px;
    font-weight: 500;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export default PreviewNotice;
